export const settings = {
  URL_IMAGE_CB_TANQUE: '/tank_analyzes/ID_TANQUE/download_cbtest_original_plate_image',
  WHATSAPP_URL: 'https://api.whatsapp.com/send/?phone=553195093854&text&app_absent=0'
}
